<template>
  <div id="header">
    <HeaderTop :msg="boasVindas"/>
    <div id="headerContainer">
      <LogoArea />      
      <SearchArea />
      <CartArea />
    </div>
  </div>
</template>

<script>
  import HeaderTop from './HeaderTop'
  import LogoArea from './LogoArea'
  import SearchArea from './SearchArea'
  import CartArea from './CartArea'

  const computed = {
    boasVindas() {
      return this.$store.state.boasVindas
    },
  }

  const components = {
    HeaderTop,
    LogoArea,
    SearchArea,
    CartArea
  }

  export default {
    name: 'Header',
    components,
    computed
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #headerContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
  }
</style>
